import { XClose } from '@untitled-ui/icons-react';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { ScrollablePanelContext, ScrollablePanelContextType } from './context';

type Props = {
    children: React.ReactNode | ((options: ScrollablePanelContextType) => React.ReactNode);
    className?: string;
};

export function ScrollablePanelHeader({ children, className = 'py-5 px-6 text-sm font-normal text-gray-600' }: Props) {
    const context = useContext(ScrollablePanelContext);

    return (
        <div className={classNames('sticky top-0 border-b bg-white', className)}>
            <button className="float-right -mr-3 -mt-2 p-2.5" type="button" onClick={context.onClose}>
                <XClose className="size-6 text-gray-400" />
            </button>
            {typeof children === 'function' ? children(context) : children}
        </div>
    );
}

export function ScrollablePanelBody({ children, className = 'p-6' }: Props) {
    const context = useContext(ScrollablePanelContext);

    return <div className={className}>{typeof children === 'function' ? children(context) : children}</div>;
}

export function ScrollablePanelFooter({ children, className = 'py-5 px-6' }: Props) {
    const context = useContext(ScrollablePanelContext);

    return (
        <div
            className={classNames('sticky bottom-0 border-t bg-white transition-shadow', className, {
                'shadow-[0_-32px_32px_#fff]': !context.didScrollBottom,
            })}
        >
            {typeof children === 'function' ? children(context) : children}
        </div>
    );
}
